export type NodeType =
  | 'START'
  | 'SEND_TEMPLATE'
  | 'SEND_MESSAGE'
  | 'WAIT_RESPONSE'
  | 'CONDITION'
  | 'TRANSFER_DEPARTMENT'
  | 'UPDATE_STATUS'
  | 'CLOSE_CONVERSATION'
  | 'SET_VARIABLE'
  | 'END';

export interface NodeConfig {
  [key: string]: any;
}

export interface FlowNodeData {
  label: string;
  nodeType: NodeType;
  config: NodeConfig;
}

export interface EdgeCondition {
  field: string;
  operator: 'equals' | 'not_equals' | 'contains' | 'not_contains' | 'starts_with' | 'ends_with';
  value: string;
}

export interface NodePaletteItem {
  type: NodeType;
  label: string;
  icon: string;
  color: string;
  description: string;
}

export const NODE_PALETTE: NodePaletteItem[] = [
  {
    type: 'START',
    label: 'Início',
    icon: '🚀',
    color: 'bg-green-500',
    description: 'Ponto de entrada do fluxo'
  },
  {
    type: 'SEND_TEMPLATE',
    label: 'Enviar Template',
    icon: '📨',
    color: 'bg-blue-500',
    description: 'Envia template WhatsApp'
  },
  {
    type: 'SEND_MESSAGE',
    label: 'Enviar Mensagem',
    icon: '💬',
    color: 'bg-indigo-500',
    description: 'Envia mensagem de texto'
  },
  {
    type: 'WAIT_RESPONSE',
    label: 'Aguardar Resposta',
    icon: '⏳',
    color: 'bg-purple-500',
    description: 'Pausa até receber resposta'
  },
  {
    type: 'CONDITION',
    label: 'Condição',
    icon: '🔀',
    color: 'bg-yellow-500',
    description: 'Decisão baseada em condições'
  },
  {
    type: 'TRANSFER_DEPARTMENT',
    label: 'Transferir',
    icon: '👤',
    color: 'bg-teal-500',
    description: 'Transfere para departamento'
  },
  {
    type: 'UPDATE_STATUS',
    label: 'Atualizar Status',
    icon: '📊',
    color: 'bg-cyan-500',
    description: 'Muda status da conversa'
  },
  {
    type: 'CLOSE_CONVERSATION',
    label: 'Encerrar',
    icon: '🔒',
    color: 'bg-red-500',
    description: 'Encerra a conversa'
  },
  {
    type: 'SET_VARIABLE',
    label: 'Definir Variável',
    icon: '💾',
    color: 'bg-pink-500',
    description: 'Define ou atualiza variável'
  },
  {
    type: 'END',
    label: 'Fim',
    icon: '🏁',
    color: 'bg-gray-500',
    description: 'Fim do fluxo (sem encerrar)'
  }
];
